import pl from 'locales/pl';
export const translations = pl;